// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"DigitalWizardPageWithTitleTemplate_themeRoot__26xM5","wizardContainer":"DigitalWizardPageWithTitleTemplate_wizardContainer__3oRoo"};